module.exports = __webpack_public_path__ + "img/menu.900d60f6.svg";